export default __webpack_public_path__ + "static/media/icon-medicamento.6f7a1d86.svg";